export default "__VITE_ASSET__6DXh24xL__"